import axios, {AxiosResponse} from 'axios'
import {SaleReportsQueryResponse} from './_models'
import {Option} from 'react-multi-select-component'
import {Response} from '../../../../_metronic/helpers'
import Swal from 'sweetalert2'

const API_URL = process.env.REACT_APP_API_URL + '/api'
const SALE_URL = `${API_URL}/sales`
const PRODUCTS_URL = `${API_URL}/products`
const url = `${API_URL}/reports`

const createGetSaleReports = (reportsBaseUrl: string, apiEndpoint: string) => {
  const url = `${process.env.REACT_APP_API_URL}${reportsBaseUrl}`
  return (query: string): Promise<SaleReportsQueryResponse> => {
    return axios
      .get(`${url}/${apiEndpoint}?${query}`)
      .then((d: AxiosResponse<SaleReportsQueryResponse>) => d.data)
  }
}

const downloadServerFile = async (
  filter: string | undefined,
  reportsBaseUrl: string,
  exportEndpoint: string,
  fileName: string
): Promise<{message: string; id: number} | void> => {
  var filterAdjust = filter !== undefined ? `?${filter}` : ''
  const url = `${process.env.REACT_APP_API_URL}${reportsBaseUrl}`
  try {
    const response = await axios({
      url: `${url}/${exportEndpoint}${filterAdjust}`,
      method: 'GET',
      responseType: 'blob',
    })
    const contentType = response.headers['content-type'] ?? ''
    if (contentType.includes('application/json')) {
      const text = await (response.data as Blob).text()
      return JSON.parse(text) as {message: string; id: number}
    }
    const href = URL.createObjectURL(response.data)
    const link = document.createElement('a')
    link.href = href
    link.setAttribute('download', fileName)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(href)
  } catch (error: any) {
    await Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: error?.response?.data?.message,
      timer: 2000,
    })
  }
}

const getSaleStatus = (): Promise<Option[] | undefined> => {
  return axios
    .get(`${SALE_URL}/statuses?all=1`)
    .then((response: AxiosResponse<Response<Option[]>>) => response.data)
    .then((response: Response<Option[]>) => response.data)
}

const getCategories = (): Promise<Option[] | undefined> => {
  return axios
    .get(`${PRODUCTS_URL}/categories/all`)
    .then((response: AxiosResponse<Response<Option[]>>) => response.data)
    .then((response: Response<Option[]>) => response.data)
}

const getAvailableProducts = (reportsBaseUrl: string): Promise<Option[] | undefined> => {
  const url = `${process.env.REACT_APP_API_URL}${reportsBaseUrl}`
  return axios
    .get(`${url}/available-products`)
    .then((response: AxiosResponse<Response<Option[]>>) => response.data)
    .then((response: Response<Option[]>) => response.data)
}

export {
  createGetSaleReports,
  downloadServerFile,
  getSaleStatus,
  getCategories,
  getAvailableProducts,
}
